// Utilidad para formatear valores en Guaraníes (PYG)
// Los guaraníes se muestran como enteros con separador de miles con punto
// Ejemplo: 1500000 -> 'Gs. 1.500.000'

export const formatGs = (value) => {
  if (value === null || value === undefined || isNaN(value)) return 'Gs. 0';
  const rounded = Math.round(Number(value));
  const formatted = rounded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `Gs. ${formatted}`;
};

export const parseGs = (value) => {
  if (!value) return 0;
  const cleaned = value.toString().replace(/[^\d-]/g, '');
  return parseInt(cleaned) || 0;
};

export const formatGsCompact = (value) => {
  if (value === null || value === undefined || isNaN(value)) return '0';
  const rounded = Math.round(Number(value));
  return rounded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};
